import React, { useEffect, useState } from 'react'
import { Chart } from 'react-google-charts'

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);


const BarChart = ({results, title, id, score}) => {

    const options = {
        fontName: 'DM Sans',
        fontSize: "16",
        // width: 600,
        height: 350,
        bar: { groupWidth: "30" },
        legend: { position: "none" },
        title: {
          titlePosition: "none"
        },
        chartArea: {
          left: 120,
        },
        hAxis: {
          minValue: 0,
          maxValue: 5,
          textPosition: "none",
          viewWindow: {
            max: 5,
            min: 0, 
          },
        },
        vAxis: {
          width: 200,
          textPosition: "out",
          textStyle: {
            fontSize: 12,
          },
        },
        tooltip: {
          isHtml: true,
          trigger: 'focus',
          // ignoreBounds: true,
        }
      }
      
      const dataConverter = (value) => {
        switch (value) {
          case "Meget uenig":
            return 1
          case "Uenig":
            return 2
          case "Hverken enig eller uenig":
            return 3
          case "Enig":
            return 4
          case "Meget enig":
            return 5
          default:
            console.log("Cannot read values")
        }
      }

      const colorConverter = (value) => {
        switch (value) {
          case "Meget uenig":
            return "#8C1C13"
          case "Uenig":
            return "#E4572E"
          case "Hverken enig eller uenig":
            return "#FFB800"
          case "Enig":
            return "#AAE2C9"
          case "Meget enig":
            return "#56C693"
          default:
            console.log("Cannot read values")
        }
      }

      const data = [ ["Question","Answer", { role: 'style' }, { role: 'tooltip', type: "string", p: { html: true } }] ]       
      switch (results.length){
        case 3:
          data.push(                       
            [results[0].qst_short, dataConverter(results[0].value), colorConverter(results[0].value), `<p>${results[0].qst}</p><h1>${results[0].value}</h1>`],
            [results[1].qst_short, dataConverter(results[1].value), colorConverter(results[1].value), `<p>${results[1].qst}</p><h1>${results[1].value}</h1>`],
            [results[2].qst_short, dataConverter(results[2].value), colorConverter(results[2].value), `<p>${results[2].qst}</p><h1>${results[2].value}</h1>`],
            )
            break
        case 4: 
          data.push(           
            [results[0].qst_short, dataConverter(results[0].value), colorConverter(results[0].value), `<p>${results[0].qst}</p><h1>${results[0].value}</h1>`],
            [results[1].qst_short, dataConverter(results[1].value), colorConverter(results[1].value), `<p>${results[1].qst}</p><h1>${results[1].value}</h1>`],
            [results[2].qst_short, dataConverter(results[2].value), colorConverter(results[2].value), `<p>${results[2].qst}</p><h1>${results[2].value}</h1>`],
            [results[3].qst_short, dataConverter(results[3].value), colorConverter(results[3].value), `<p>${results[3].qst}</p><h1>${results[3].value}</h1>`],  
          )
          break
        case 5: 
          data.push(           
            [results[0].qst_short, dataConverter(results[0].value), colorConverter(results[0].value), `<p>${results[0].qst}</p><h1>${results[0].value}</h1>`],
            [results[1].qst_short, dataConverter(results[1].value), colorConverter(results[1].value), `<p>${results[1].qst}</p><h1>${results[1].value}</h1>`],
            [results[2].qst_short, dataConverter(results[2].value), colorConverter(results[2].value), `<p>${results[2].qst}</p><h1>${results[2].value}</h1>`],
            [results[3].qst_short, dataConverter(results[3].value), colorConverter(results[3].value), `<p>${results[3].qst}</p><h1>${results[3].value}</h1>`],
            [results[4].qst_short, dataConverter(results[4].value), colorConverter(results[4].value), `<p>${results[4].qst}</p><h1>${results[4].value}</h1>`],   
          )
          break
        default: 
          console.log("Cannot load results")
      }
      
      const [toggle, setToggle] = useState(true);

      useEffect(() => {
        setTimeout(()=>{
          setToggle(false)
        }, 1000)

      },[])

      
  return (
    <>
      <div className='__chart-container'>
        <div className='d-flex'>
          <button className="__button __chart-title" onClick={() => setToggle(!toggle)}  >{title}</button>
          <button className="__button __chart-score" onClick={() => setToggle(!toggle)}  >{score}</button>
        </div>

        <div className={toggle ? '__show' : '__hide'}>
          <Chart chartType='BarChart' data={data} options={options} /> 
        </div>

      </div>
    </>
  )
}

export default BarChart